import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

// A calm section heading with a count. When `collapsible`, the heading is a button that
// expands/folds its items inline (no route, no page). Collapsed shows the count only.
// `accent` lets a section tint its count chip (e.g. partner = slate) without urgency styling.
export function CollapsibleSection({
  id,
  title,
  count,
  hint,
  collapsible = false,
  defaultOpen = true,
  accent = "ink",
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const isOpen = collapsible ? open : true;

  const chipCls =
    accent === "slate"
      ? "text-[var(--slate)] bg-[var(--slate-soft)]"
      : accent === "pine"
      ? "text-[var(--pine)] bg-[var(--pine-soft)]"
      : "text-[var(--ink3)] bg-[var(--line2)]";

  const titleCls =
    accent === "slate"
      ? "text-[var(--slate)]"
      : accent === "pine"
      ? "text-[var(--pine)]"
      : "text-[var(--ink)]";

  const Heading = (
    <>
      <h2 className={`text-xl font-medium ${titleCls}`}>{title}</h2>
      {count != null && (
        <span className={`text-xs font-semibold rounded-full px-2 py-0.5 ${chipCls}`} data-testid={`${id}-count`}>
          {count}
        </span>
      )}
      {hint && <span className="text-sm text-[var(--ink4)] hidden md:inline">{hint}</span>}
    </>
  );

  return (
    <section data-testid={`section-${id}`}>
      {collapsible ? (
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={isOpen}
          data-testid={`section-toggle-${id}`}
          className="group/sec w-full flex items-baseline gap-3 mb-4 text-left rounded-lg -mx-1 px-1 py-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--pine-line)]"
        >
          {Heading}
          <ChevronDown
            size={17}
            strokeWidth={2}
            className={`text-[var(--ink4)] ml-auto shrink-0 transition-transform duration-200 group-hover/sec:text-[var(--ink3)] ${isOpen ? "" : "-rotate-90"}`}
          />
        </button>
      ) : (
        <div className="flex items-baseline gap-3 mb-4">{Heading}</div>
      )}
      {isOpen && children}
    </section>
  );
}

export default CollapsibleSection;
